import {
  BrainIcon,
  HeartbeatIcon,
  MoonStarsIcon,
  SparkleIcon,
  ActivityIcon,
  SocialIcon,
  EmotionalSupportIcon,
  DotsThreeIcon,
} from 'components/Icons';
import { Color } from 'utils/color';

export const CATEGORY_ICON_MAP = {
  wellbeing: {
    icon: SparkleIcon,
    color: Color.DARK_GREEN
  },
  'emotional support': {
    icon: EmotionalSupportIcon,
  },
  'cognitive support': {
    icon: BrainIcon,
  },
  'activity': {
    icon: ActivityIcon,
  },
  'health': {
    icon: HeartbeatIcon,
  },
  'social connection': {
    icon: SocialIcon,
  },
  'sleep': {
    icon: MoonStarsIcon,
  },
  'other': {
    icon: DotsThreeIcon
  }
}
